import { render, staticRenderFns } from "./ExportsList.vue?vue&type=template&id=0ef3c64a"
import script from "./ExportsList.vue?vue&type=script&lang=js"
export * from "./ExportsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports